
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as indexv5BLwqT1luMeta } from "/var/lib/jenkins/workspace/paxgon/pages/about/index.vue?macro=true";
import { default as indexe8oME3FPxHMeta } from "/var/lib/jenkins/workspace/paxgon/pages/concat/index.vue?macro=true";
import { default as indexAiTJfh3R37Meta } from "/var/lib/jenkins/workspace/paxgon/pages/index.vue?macro=true";
import { default as _91id_93umnlgcTZiyMeta } from "/var/lib/jenkins/workspace/paxgon/pages/industry/detail/[id].vue?macro=true";
import { default as indexfnQPXfNymSMeta } from "/var/lib/jenkins/workspace/paxgon/pages/industry/index.vue?macro=true";
import { default as indexS565UBRWvyMeta } from "/var/lib/jenkins/workspace/paxgon/pages/ourpartners/index.vue?macro=true";
import { default as _91id_93ocw1BvbpcTMeta } from "/var/lib/jenkins/workspace/paxgon/pages/ourwork/detail/[id].vue?macro=true";
import { default as index3VhxOsgBMKMeta } from "/var/lib/jenkins/workspace/paxgon/pages/ourwork/index.vue?macro=true";
import { default as indexTes1NI5O7pMeta } from "/var/lib/jenkins/workspace/paxgon/pages/service/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/about/index.vue")
  },
  {
    name: "concat",
    path: "/concat",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/concat/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/index.vue")
  },
  {
    name: "industry-detail-id",
    path: "/industry/detail/:id()",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/industry/detail/[id].vue")
  },
  {
    name: "industry",
    path: "/industry",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/industry/index.vue")
  },
  {
    name: "ourpartners",
    path: "/ourpartners",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/ourpartners/index.vue")
  },
  {
    name: "ourwork-detail-id",
    path: "/ourwork/detail/:id()",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/ourwork/detail/[id].vue")
  },
  {
    name: "ourwork",
    path: "/ourwork",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/ourwork/index.vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/var/lib/jenkins/workspace/paxgon/pages/service/index.vue")
  }
]